import { render, staticRenderFns } from "./RealName.vue?vue&type=template&id=1b7b2c79&scoped=true&"
import script from "./RealName.vue?vue&type=script&lang=js&"
export * from "./RealName.vue?vue&type=script&lang=js&"
import style0 from "./RealName.vue?vue&type=style&index=0&id=1b7b2c79&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7b2c79",
  null
  
)

export default component.exports